<!-- 注册页面 -->
<template>
  <div class="body-wrap">
    <div class="body-inner-wrap">
      <div class="body-top">
        <router-link tag="h2" class="pointer" to="/">高校企业服务内网</router-link>
        <p>
          已有账号，现在
          <router-link tag="a" to="/login">登录</router-link>
        </p>
      </div>
      <div class="register-content">
        <div class="reg-inner-container">
          <h3>欢迎注册高校企业服务内网</h3>
          <ul class="reg-form">
            <li class="reg-form-item" :class="{error: usernameerror != ''}">
              <el-popover placement="right" width="300" trigger="click">
                <ul class="ent-formtips-ul">
                  <li>用户名区分大小写</li>
                  <li>6 - 18 个字符</li>
                  <li>只能包含英文字母、数字、下划线</li>
                  <li>必须同时包含字母、数字两种</li>
                </ul>
                <input
                  type="text"
                  v-model="username"
                  @blur="handleblur('username')"
                  maxlength="18"
                  slot="reference"
                  placeholder="用户名"
                />
              </el-popover>
              <i class="el-icon-loading diyloadingicon" v-if="showloading"></i>
              <p class="error-info" v-if="usernameerror != ''">{{usernameerror}}</p>
            </li>
            <li class="reg-form-item" :class="{error: pwderror != ''}">
              <el-popover placement="right" width="300" trigger="click">
                <ul class="ent-formtips-ul">
                  <li>6 - 18 个字符</li>
                  <li>只能包含英文字母、数字</li>
                  <li>必须同时包含字母、数字两种</li>
                </ul>
                <input
                  type="password"
                  v-model="password"
                  @blur="handleblur('password')"
                  maxlength="18"
                  slot="reference"
                  placeholder="密码"
                />
              </el-popover>
              <p class="error-info" v-if="pwderror != ''">{{pwderror}}</p>
            </li>
            <li class="reg-form-item" :class="{error: confirmpwderror != ''}">
              <el-popover placement="right" width="300" trigger="click">
                <ul class="ent-formtips-ul">
                  <li>请再次输入密码</li>
                </ul>
                <input
                  type="password"
                  v-model="repassword"
                  @blur="handleblur('repassword')"
                  maxlength="18"
                  slot="reference"
                  placeholder="确认密码"
                />
              </el-popover>
              <p class="error-info" v-if="confirmpwderror != ''">{{confirmpwderror}}</p>
            </li>
            <li class="reg-form-item" :class="{error: phoneerror != ''}">
              <el-popover placement="right" width="300" trigger="click">
                <ul class="ent-formtips-ul">
                  <li>请输入手机号</li>
                </ul>
                <input
                  type="text"
                  v-model="phone"
                  @blur="handleblur('phone')"
                  maxlength="11"
                  slot="reference"
                  placeholder="手机号码"
                />
              </el-popover>
              <p class="error-info" v-if="phoneerror != ''">{{phoneerror}}</p>
            </li>
            <li class="reg-form-item" :class="{error: imgcodeerror != ''}">
              <div class="reg-form-input-top">
                <input type="text" v-model="imgcode" placeholder="请输入图片验证码" />
                <img :src="imgCodeUrl" @click="getNewCodeImgKey" alt="换一张" />
              </div>
              <p class="error-info" v-if="imgcodeerror != ''">{{imgcodeerror}}</p>
            </li>
            <li class="reg-form-item" :class="{error: msgcodeerror != ''}">
              <div class="reg-form-input-top">
                <input type="text" v-model="msgcode" placeholder="请输入短信验证码" />
                <getCode
                  :phonenum="phone"
                  :imgcode="imgcode"
                  :uuid="randomKey"
                  v-on:handleerror="handleerror"
                  type="13"
                  ref="code"
                  class="msgcode-wrap"
                ></getCode>
              </div>
              <p class="error-info" v-if="msgcodeerror != ''">{{msgcodeerror}}</p>
            </li>
            <li class="reg-form-accept">
              <input type="checkbox" v-model="isaccept" />
              <p>
                我已阅读并接受
                <router-link tag="a" target="_blank" to="/userprivcy">用户协议</router-link>和
                <router-link tag="a" target="_blank" to="/userprivcy">隐私条款</router-link>
              </p>
            </li>
            <li class="reg-form-bottom">
              <button @click="submitform()">提交注册</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- footer -->
    <my-footer></my-footer>
  </div>
</template>

<script>
import {
  isPhoneAvailable
} from '@/util/utils.js'
import getCode from '@/components/getMsgCode/getMsgCode.vue'
import {
  Popover,
  Icon
} from 'element-ui'
import vFooter from '@/components/footer/footer.vue'

export default {
  name: 'register',
  components: {
    'my-footer': vFooter,
    'getCode': getCode,
    'el-popover': Popover,
    'el-icon': Icon
  },
  data () {
    return {
      imgcode: '',
      imgcodeerror: '',
      username: '',
      password: '',
      usernameerror: '',
      pwderror: '',
      repassword: '',
      confirmpwderror: '',
      phone: '',
      phoneerror: '',
      msgcode: '',
      msgcodeerror: '',
      msgPinCode: '',
      isaccept: false,
      randomKey: this.getNewCodeImgKey(),
      imgCodeUrl: this.commonapi + '/captcha?uuid=' + this.randomKey,
      showloading: false,
      isusernamecan: false
    }
  },
  created () {
    this.getNewCodeImgKey()
  },
  methods: {
    // 生成图片验证码Key
    getNewCodeImgKey () {
      // this.randomKey = Math.ceil(Math.random() * 1000) // 生成一个随机key（防止缓存)
      this.randomKey = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      this.imgCodeUrl = this.commonapi + '/captcha?uuid=' + this.randomKey
    },
    submitform () {
      if (this.isUsernameAvailable() && this.isPasswordAvailable() && this.isRePasswordAvailable() && this.isPhoneAvailable() && this.isMsgcodeAvailable()) {
        if (!this.isaccept) {
          this.$message.info('请先阅读并接受用户协议和隐私条款')
          return false
        }
        if (!this.isusernamecan) {
          this.usernameerror = '用户名已存在'
          this.$message.info('用户名已存在！')
          return false
        }
        let data = {
          loginName: this.username,
          password: this.password,
          mobile: this.phone,
          smsCode: this.msgcode,
          pinToken: this.$refs.code.pinToken
        }
        this.$http({
          method: 'POST',
          url: '/register/submit',
          params: data
        }).then(res => {
          if (res.code === 100) {
            this.$router.push({ path: '/certification' })
          } else {
            this.$alert(res.msg)
          }
        }).catch(error => {
          console.log(error)
        })
      }
    },
    handleerror (msg) {
      this.msgcodeerror = msg
      this.getNewCodeImgKey()
    },
    handleblur (type) {
      if (type === 'username') {
        this.isUsernameAvailable()
      } else if (type === 'password') {
        this.isPasswordAvailable()
      } else if (type === 'repassword') {
        this.isRePasswordAvailable()
      } else if (type === 'phone') {
        this.isPhoneAvailable()
      }
    },
    isMsgcodeAvailable () {
      if (this.msgcode === '') {
        this.msgcodeerror = '请输入短信验证码'
        return false
      } else if (this.$refs.code.pinToken === '') {
        this.msgcodeerror = '请先获取短信验证码'
        return false
      } else {
        this.msgcodeerror = ''
        return true
      }
    },
    isUsernameAvailable () {
      let isabcreg = /^[A-Za-z]+$/
      let is123reg = /^[0-9]*$/
      let isunreg = /^[_]+$/
      let is123unreg = /^[0-9_]+$/
      let lengthreg = /^.{6,18}$/
      let isrightreg = /^(?![0-9_]+$)(?![a-zA-Z_]+$)[0-9A-Za-z_]{6,18}$/
      if (this.username === '') {
        this.usernameerror = '用户名不能为空'
        return false
      }
      if (new RegExp(is123reg).test(this.username)) {
        this.usernameerror = '用户名不能为纯数字'
        return false
      }
      if (new RegExp(is123reg).test(this.username) || new RegExp(isabcreg).test(this.username)) {
        this.usernameerror = '字母，数字必须包含两种'
        return false
      }
      if (new RegExp(isunreg).test(this.username)) {
        this.usernameerror = '用户名不能只包含下划线'
        return false
      }
      if (!(new RegExp(lengthreg).test(this.username))) {
        this.usernameerror = '用户名长度需要为6-18个字符'
        return false
      }
      if (new RegExp(is123unreg).test(this.username)) {
        this.usernameerror = '用户名必须包含英文字母'
        return false
      }
      if (new RegExp(isrightreg).test(this.username)) {
        this.usernameerror = ''
        this.showloading = true
        let data = {
          loginName: this.username
        }
        this.$http({
          method: 'POST',
          url: '/register/name/usable',
          params: data
        }).then(res => {
          if (res.code !== 100) {
            this.usernameerror = '用户名已存在'
            this.isusernamecan = false
            this.showloading = false
            return false
          } else {
            this.usernameerror = ''
            this.isusernamecan = true
            this.showloading = false
            return true
          }
        }).catch(error => {
          console.log(error)
          this.showloading = false
        })
        return true
      } else {
        this.usernameerror = '只能包含字母、数字、下划线，且必须包含字母和数字两种'
        return false
      }
    },
    isPasswordAvailable () {
      let isabc123reg = /^[A-Za-z0-9]+$/
      let isall123reg = /^[0-9]+$/
      let isallabcreg = /^[a-zA-Z]+$/
      // let isall$reg = /^[\!@#\$%\^&\*\.,\+]+$/
      let lengthreg = /^.{6,18}$/
      if (this.password === '') {
        this.pwderror = '密码不能为空'
        return false
      }
      if (new RegExp(isall123reg).test(this.password) || new RegExp(isallabcreg).test(this.password)) {
        this.pwderror = '字母，数字必须包含两种'
        return false
      }
      if (!new RegExp(lengthreg).test(this.password)) {
        this.pwderror = '密码长度需要为6-18个字符'
        return false
      }
      if (new RegExp(isabc123reg).test(this.password)) {
        this.pwderror = ''
        return true
      }
      this.pwderror = '密码只能包含英文字母或数字'
      return false
    },
    isRePasswordAvailable () {
      if (this.repassword === '') {
        this.confirmpwderror = '请再次输入您的密码'
        return false
      }
      if (this.password !== this.repassword) {
        this.confirmpwderror = '两次密码输入不一致'
        return false
      }
      this.confirmpwderror = ''
      return true
    },
    isPhoneAvailable () {
      if (this.phone === '') {
        this.phoneerror = '手机号码不能为空'
        return false
      }
      if (isPhoneAvailable(this.phone)) {
        this.phoneerror = ''
        return true
      }
      this.phoneerror = '手机号码格式不合法'
      return false
    }
  }
}

</script>

<style src='./register.scss' lang='scss' scoped></style>



// WEBPACK FOOTER //
// src/views/register/register.vue